import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <p className="text-ink/50 text-sm tracking-[0.18em] uppercase">Loading</p>
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/studio/login" state={{ from: location }} replace />;
  }
  return children;
}
